<template>
  <v-menu v-model="show" :close-on-content-click="false" width="300">
    <template #activator="{ props: menuProps }">
      <EmIconButton
        icon="mdi-volume-high"
        title="Audio Settings"
        v-bind="menuProps"
      />
    </template>
    <template #default>
      <v-card>
        <v-card-text>
          <div class="mb-4">
            <EmSelect
              id="input-source"
              v-model="callStore.inputSource"
              :items="callStore.availableInputSources"
              item-title="label"
              item-value="deviceId"
              label="Input Source"
              hide-details
              @update:model-value="callStore.changeInputSource"
            />
          </div>
          <div>
            <EmSelect
              id="output-source"
              v-model="callStore.outputSource"
              :items="callStore.availableOutputSources"
              item-title="label"
              item-value="deviceId"
              label="Speaker Source"
              hide-details
              @update:model-value="callStore.changeOutputSource"
            />
          </div>
        </v-card-text>
      </v-card>
    </template>
  </v-menu>
</template>

<script setup>
const callStore = useCallStore()
const show = ref(false)
watch(() => callStore.callInProgress, (newValue) => {
  if (!newValue) {
    show.value = false
  }
})
</script>
